module.exports = __webpack_public_path__ + "img/ic_mediaControl.6c9b537d.svg";